import { render, staticRenderFns } from "./CartItemAmerican.vue?vue&type=template&id=c8485346&scoped=true"
import script from "./CartItemAmerican.vue?vue&type=script&lang=js"
export * from "./CartItemAmerican.vue?vue&type=script&lang=js"
import style0 from "./CartItemAmerican.vue?vue&type=style&index=0&id=c8485346&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8485346",
  null
  
)

export default component.exports